module.exports = __webpack_public_path__ + "img/gke.deaff14c.svg";